import { useState } from "react";
import { ReactComponent as CrossIcon } from "../../../assets/icons/close.svg";
import "../../../css/DesignSystem/Inputs/SearchField.css";

export default function SearchInput({
  value,
  onChange,
  placeholder = "Search Client Name",
  disabled = false,
  onSubmit,
  label = "",
  suggestions = [],
  onSuggestionSelect,
}) {
  const [focused, setFocused] = useState(false);
  const hasValue = (value ?? "").length > 0;

  const handleChange = (e) => {
    // console.log(e);
    const next = e?.target ? e.target.value : e; // support string or event
    onChange?.(next ?? "");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && onSubmit) onSubmit(value || "");
  };

  const clear = () => onChange?.("");

  return (
    <div className="ds-input-field" style={{ position: "relative" }}>
      {label && <div className="Content">{label}</div>}
      <div className="ds-input-wrapper ds-input-wrapper--search">
        <input
          className="ds-input"
          type="text"
          value={value ?? ""}
          onChange={handleChange}
          placeholder={placeholder || "Enter a postcode/address to search"}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <CrossIcon style={{ cursor: "pointer" }} onClick={clear} />
      </div>
      {suggestions.length > 0 && (
        <ul className="ds-input-suggestions">
          {suggestions.map((s, idx) => (
            <li
              key={s.global_address_key || idx}
              className="ds-input-suggestion Content-Small"
              onClick={() => onSuggestionSelect?.(s)}
            >
              {s.raw.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
